import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function SendMessageFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M22.3886 3.50934C22.9207 2.01947 21.4821 0.580923 19.9922 1.11301L2.24451 7.45149C0.477796 8.08246 0.630217 10.6298 2.45959 11.0455L9.59327 12.648L13.3909 8.73607C13.7756 8.3398 14.4087 8.33041 14.8049 8.7151C15.2012 9.09979 15.2106 9.73289 14.8259 10.1292L10.9106 14.1623L12.456 21.042C12.8718 22.8714 15.4191 23.0238 16.0501 21.2571L22.3886 3.50934Z"
				fill="currentColor"
			/>
		</svg>
	);
}

SendMessageFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default SendMessageFilledIcon;
